var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 228 228",
    className: "outlined-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 114,
    r: 114
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.1923 49.3306L114 62.446L128.808 49.3306"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.085 78.269L114 88.4229L124.915 78.269"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114 38.5V110.169"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0077 92.4L72.7077 86.1385L68.7308 66.8462"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9153 103.485L95.1307 99.0846L91.8307 84.5308"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9769 74.123L114 110"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3923 153.323L72.3692 133.946L53.5846 127.769"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4923 135.554L94.7923 121L80.5769 116.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5538 145.962L113.577 110.169"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.808 170.669L114 157.554L99.1923 170.669"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.915 141.731L114 131.577L103.085 141.731"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114 181.5V109.831"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.992 127.431L155.292 133.692L159.269 153.069"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.085 116.346L132.869 120.746L136.169 135.3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.023 145.707L114 109.831"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M159.608 66.6768L155.631 86.0537L174.415 92.2306"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.508 84.4458L133.208 98.9996L147.423 103.4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.446 74.0386L114.423 109.831"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinter);
export default __webpack_public_path__ + "static/media/winter.cbe64ffb.svg";
export { ForwardRef as ReactComponent };